<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline"
    :class="[width, height]"
    viewBox="0 0 36.576 36.576"
  >
    <path
      id="Path_936"
      data-name="Path 936"
      d="M481.281,1060.9a4.471,4.471,0,0,1,4.469,4.469v27.638a4.471,4.471,0,0,1-4.469,4.469h-7.606V1083.7h4.758l.906-5.9h-5.663v-3.83c0-1.615.791-3.189,3.328-3.189h2.575v-5.025a31.384,31.384,0,0,0-4.571-.4c-4.664,0-7.713,2.827-7.713,7.944v4.5H462.11v5.9h5.184v13.781H453.643a4.471,4.471,0,0,1-4.469-4.469V1065.37a4.472,4.472,0,0,1,4.469-4.469Z"
      transform="translate(-449.174 -1060.901)"
      fill="#1777f2"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-9'
    },
    height: {
      type: String,
      default: 'h-9'
    }
  }
}
</script>
